var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('sidebar'),_c('v-main',{attrs:{"id":"main-content"}},[_c('router-view',{attrs:{"id":"announce","aria-live":"polite"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }